(function ($) {
    /**
     *
     * @returns {*}
     */
    $.fn.productionSpool = function (batch, data = null) {
        return this.each(function (index, element) {
            let spool = this;
            spool.batch = batch;

            spool.batchName = null;
            spool.btnDelete = null;
            spool.btnSpoolPrint = null;
            spool.btnSpoolPrintNext = null;
            spool.btnSpoolSave = null;
            spool.fieldBatchName = null;
            spool.fieldGrossWeight = null;
            spool.fieldMeters = null;
            spool.fieldNettoWeight = null;
            spool.fieldTubeInt = null;
            spool.form = null;
            spool.grossWeight = null;
            spool.labelPrinter = null;
            spool.labelSettings = null;
            spool.nettorWeight = null;
            spool.printer = null;
            spool.showMeters = null;
            spool.showNumber = null;
            spool.spoolId = null;
            spool.tubeInt = null;
            spool.boxInt = null;
            spool.disabledNextButton = false;

            /**
             *
             */
            spool.init = (data) => {
                spool.initData();
                spool.initElements();
                spool.initButtons();
                spool.setFields();
                spool.setData(data);
                spool.postInit();
            }

            /**
             *
             */
            spool.initData = () => {
                spool.labelSettings = spool.batch.box.pallet.production.getLabelSettings('spool');
                spool.showMeters = spool.labelSettings.meters === true;
            }

            /**
             *
             */
            spool.initElements = () => {
                spool.btnDelete = $('i.sf-delete.spool-delete', $(spool));
                spool.btnSpoolPrint = $('button.spool-print', $(spool));
                spool.btnSpoolPrintNext = $('button.spool-print-next', $(spool));
                spool.btnSpoolSave = $('button.spool-save', $(spool));
                spool.form = $('form.spools-form', $(spool));
                spool.fieldBatchName = $('[name="name"]', spool.form);
                spool.fieldGrossWeight = $('[name="gross_weight"]', spool.form);
                spool.fieldMeters = $('[name="meters"]', spool.form);
                spool.fieldNettoWeight = $('.netto_weight', spool.form);
                spool.fieldTubeInt = $('.tube_int', spool.form);
                spool.showNumber = $('span.spool-no', $(spool));

                spool.labelPrinter = $(spool).fnLabelPrinter();

                spool.fieldGrossWeight.off('change blur').on('change blur', function () {
                    spool.setGrossWeight($(this).val().replace(',', '.'));
                });

                spool.fieldMeters.off('change blur').on('change blur', function () {
                    let meters = $(this).val().replace(',', '.');
                    spool.setMeters(meters);
                });

                spool.btnDelete.off('click keydown').on('click keydown', (event) => {
                    event.stopPropagation();
                    event.preventDefault();
                    spool.delete(event);
                });

                spool.addEventListener('keydown', (event) => {
                    if ((event.key === 'Enter') && ($(event.target).attr('name') === 'gross_weight')) {
                        event.preventDefault();
                        spool.btnSpoolPrintNext.click();
                    }
                });

                if (spool.showMeters === false) {
                    $('tr.meters', spool.form).hide();
                }

                if (spool.disabledNextButton === true) {
                    spool.btnSpoolPrintNext.prop('disabled', true);
                }
            }

            /**
             *
             */
            spool.setFields = () => {
                spool.setTubeInt();
                spool.setGrossWeight();
                spool.setMeters();
            }

            /**
             *
             */
            spool.initButtons = () => {
                spool.btnSpoolSave.off('click keydown').on('click keydown', () => {
                    window.blur();
                    spool.save();
                });
                spool.btnSpoolPrint.off('click keydown').on('click keydown', () => {
                    window.blur();
                    spool.save(() => {
                        spool.print();
                    });
                });
                spool.btnSpoolPrintNext.off('click keydown').on('click keydown', () => {
                    spool.btnSpoolPrintNext.prop('disabled', true);
                    window.blur();
                    spool.save(() => {
                        spool.batch.newSpool(null, true);
                        spool.print();
                    });
                });
            }

            /**
             *
             */
            spool.postInit = () => {

            }

            /**
             *
             * @returns {{box_id: *, batch_name: *, spool_id: *, batch_id: *, product_id: *, sales_order_id: *, gross_weight: *, tube_int: *, pallet_id: *, meters: *}}
             */
            spool.getData = () => {
                return {
                    batch_id: spool.getBatchId(),
                    batch_name: spool.getBatchName(),
                    box_id: spool.getBoxId(),
                    gross_weight: spool.getGrossWeight(),
                    meters: spool.getMeters(),
                    netto_weight: spool.getNettoWeight(),
                    pallet_id: spool.getPalletId(),
                    product_id: spool.getProductId(),
                    sales_order_id: spool.getSalesOrderId(),
                    sales_order_line_id: spool.getSalesOrderLineId(),
                    spool_id: spool.getSpoolId(),
                    tube_int: spool.getTubeInt(),
                    box_int: spool.getBoxInt(),

                    code: spool.batch.box.getCode(),
                    box_number: spool.batch.box.getNumber(),
                    customer_code: spool.batch.box.getCustomerCode(),
                    pid: spool.batch.box.getPid(),
                }
            }

            /**
             *
             * @param callback
             * @param force
             */
            spool.save = (callback = null, force = true) => {
                if (!force && (!(spool.getGrossWeight() > 0))) {
                    return null;
                }
                spool.setGrossWeight(spool.fieldGrossWeight.val());
                spool.setMeters(spool.fieldMeters.val());

                $.ajax({
                    type: "POST",
                    url: '/admin/spools',
                    data: spool.getData(),
                    dataType: "json",
                    encode: true,
                    success: function (response) {
                        spool.setPalletId(response.pallet_id);
                        spool.setBoxId(response.box_id);
                        spool.setSpoolId(response.spool_id);

                        spool.batch.box.setBatches();
                        spool.batch.box.setReels();
                        spool.batch.box.setMeters();
                        spool.batch.box.setNettoWeight();
                        if (callback) {
                            callback();
                        }
                        if (force) {
                            spool.batch.box.updatePackagingProgress();
                        }
                        return true;
                    },
                    error: function (response) {
                        if (response.error !== undefined) {
                            alert(response.error);
                        } else {
                            alert(JSON.parse(response.responseText).message);
                        }
                        return false;
                    }
                });
                return true;
            }

            /**
             *
             */
            spool.print = () => {
                let data = spool.getData();
                let content = spool.labelPrinter.getTemplate(spool.labelSettings, data, 'spool');
                if (content === null) {
                    return false;
                }

                if (spool.printer === null) {
                    spool.printer = spool.labelPrinter.getDeviceByUid(spool.batch.box.pallet.production.labelPrinterSpool);
                }
                spool.labelPrinter.write(spool.printer, content);
            }

            /**
             *
             */
            spool.calculateNettoWeight = () => {
                let grossWeight = spool.getGrossWeight();
                let spoolWeight = spool.batch.box.getSpoolWeight();
                let nettoWeight = 0;

                if ((grossWeight > 0) && (spoolWeight >= 0)) {
                    nettoWeight = grossWeight;
                    if (spoolWeight > 0) {
                        nettoWeight = grossWeight - spoolWeight;
                    }
                }
                spool.setNettoWeight(nettoWeight);
            }

            /**
             *
             * @returns {*}
             */
            spool.getBatchId = () => {
                return spool.batch.box.pallet.production.getBatchId();
            }

            /**
             *
             * @returns {*}
             */
            spool.getBatchName = () => {
                return spool.batch.box.pallet.production.getBatchName();
            }

            /**
             *
             * @returns {*}
             */
            spool.getBoxId = () => {
                return spool.batch.getBoxId();
            }

            /**
             *
             * @returns {null|number|*}
             */
            spool.getGrossWeight = () => {
                return spool.grossWeight;
            }

            /**
             *
             * @returns {number|*}
             */
            spool.getMeters = () => {
                return spool.meters;
            }

            /**
             *
             * @returns {number|number|*}
             */
            spool.getNettoWeight = () => {
                return spool.nettoWeight;
            }

            /**
             *
             * @returns {*}
             */
            spool.getPalletId = () => {
                return spool.batch.getPalletId();
            }

            /**
             *
             * @returns {*}
             */
            spool.getProductId = () => {
                return spool.batch.getProductId();
            }

            /**
             *
             * @returns {*}
             */
            spool.getSalesOrderId = () => {
                return spool.batch.getSalesOrderId();
            }

            /**
             *
             * @returns {*}
             */
            spool.getSalesOrderLineId = () => {
                return spool.batch.getSalesOrderLineId();
            }

            /**
             *
             * @returns {null|*}
             */
            spool.getSpoolId = () => {
                return spool.spoolId;
            }

            spool.getPickedStatus = () => {
                return spool.picked;
            }

            /**
             *
             * @returns {null|*|number}
             */
            spool.getTubeInt = () => {
                if (!parseInt(spool.tubeInt) > 0) {
                    spool.setTubeInt();
                }
                return spool.tubeInt;
            }

            /**
             *
             * @returns {null|*|number}
             */
            spool.getBoxInt = () => {
                if (!parseInt(spool.boxInt) > 0) {
                    spool.setBoxInt();
                }
                return spool.boxInt;
            }

            /**
             *
             * @param data
             */
            spool.setData = (data) => {
                if (data !== null) {
                    spool.setGrossWeight(data.gross_weight);
                    spool.setMeters(data.meters);
                    spool.setNettoWeight(data.netto_weight);
                    spool.setSpoolId(data.id);
                    spool.setTubeInt(data.tube_int);
                    spool.setBoxInt();
                    spool.setPickedStatus(data?.picked);
                }
            }

            /**
             *
             * @param box_id
             */
            spool.setBoxId = (box_id) => {
                spool.batch.setBoxId(box_id);
            }

            /**
             *
             * @param gross_weight
             */
            spool.setGrossWeight = (gross_weight) => {
                let grossWeight = ((parseFloat(gross_weight) > 0) ? parseFloat(gross_weight) : 0);
                spool.grossWeight = grossWeight;
                spool.fieldGrossWeight.val(((grossWeight > 0) ? grossWeight.toFixed(2) : ''));
                spool.calculateNettoWeight();
            }

            /**
             *
             * @param netto_weight
             */
            spool.setNettoWeight = (netto_weight) => {
                let nettoWeight = ((parseFloat(netto_weight) > 0) ? parseFloat(netto_weight) : 0);
                spool.nettoWeight = nettoWeight;
                spool.fieldNettoWeight.text(((nettoWeight > 0) ? nettoWeight.toFixed(2) + ' kg' : ''));
                spool.convertNettoWeightToMeters();
                spool.batch.box.setNettoWeight();
            }

            /**
             *
             */
            spool.convertNettoWeightToMeters = () => {
                let productConversionKgM = batch.box.pallet.production.productConversionKgM;
                if (parseFloat(productConversionKgM) > parseFloat(0)) {
                    let meters = parseFloat(spool.nettoWeight) / parseFloat(productConversionKgM);
                    spool.setMeters(meters);
                }
            }

            /**
             *
             * @param meters
             */
            spool.setMeters = (meters) => {
                let metersAmount = ((parseFloat(meters) > 0) ? parseFloat(meters) : 0);
                spool.meters = metersAmount;
                spool.fieldMeters.val(((metersAmount > 0) ? metersAmount.toFixed(2) : ''));
                spool.batch.box.setMeters();
            }

            spool.setPickedStatus = (picked, fromParent = false) => {
                const normalized = (picked === true || picked === 1 || picked === '1');
                // Only update the spool's own picked state if not coming from a parent override
                if (!fromParent) {
                    spool.picked = normalized;
                }
                const effectivePicked = fromParent ? (normalized ? true : (spool.picked === true || spool.picked === 1 || spool.picked === '1')) : (spool.picked === true || spool.picked === 1 || spool.picked === '1');

                const container = $(spool);
                if (effectivePicked) {
                    spool.btnSpoolSave.prop('disabled', true).addClass('disabled');
                    spool.btnDelete.prop('disabled', true).addClass('disabled');
                    spool.fieldGrossWeight.prop('disabled', true);
                    spool.fieldMeters.prop('disabled', true);
                    $('i.sf-delete.spool-delete', container).css('display', 'none');
                    $('.background-batch', container).addClass('disabled');
                    $('.picked-message-row', container).css('display', 'contents');
                } else {
                    spool.btnSpoolSave.prop('disabled', false).removeClass('disabled');
                    spool.btnDelete.prop('disabled', false).removeClass('disabled');
                    spool.fieldGrossWeight.prop('disabled', false);
                    spool.fieldMeters.prop('disabled', false);
                    $('i.sf-delete.spool-delete', container).css('display', 'inline-block');
                    $('.background-batch', container).removeClass('disabled');
                    $('.picked-message-row', container).css('display', 'none');
                }
            }

            /**
             *
             * @param pallet_id
             */
            spool.setPalletId = (pallet_id) => {
                spool.batch.setPalletId(pallet_id);
            }

            /**
             *
             * @param spool_id
             */
            spool.setSpoolId = (spool_id) => {
                spool.spoolId = spool_id;
                spool.btnDelete.css('display', 'inline-block');
            }

            /**
             *
             * @param tube_int
             */
            spool.setTubeInt = (tube_int = null) => {
                if (parseInt(tube_int) > 0) {
                    spool.tubeInt = parseInt(tube_int);
                } else {
                    spool.tubeInt = (spool.batch.getLastTubeInt() + 1);
                }
                spool.fieldTubeInt.text(spool.tubeInt);
                spool.showNumber.text(spool.tubeInt);
            }

            /**
             *
             * */
            spool.setBoxInt = () => {
                if (parseInt(spool.batch.box.number) > 0) {
                    spool.boxInt = parseInt(spool.batch.box.number);
                }
            }

            /**
             *
             */
            spool.delete = () => {
                confirm('Verwijderen?', () => {
                    $.ajax({
                        type: "DELETE",
                        url: '/admin/spools/' + spool.getSpoolId(),
                        encode: true,
                        success: function () {
                            spool.batch.deleteSpool(spool);
                        },
                        error: function (response) {
                            if (response.error !== undefined) {
                                alert(response.error);
                            } else {
                                alert(JSON.parse(response.responseText).message);
                            }
                            return false;
                        }
                    })
                }, null);
            }

            spool.init(data);

            return spool;
        })[0];
    }

}(jQuery));
